import { FC } from "react";
import { useTranslation } from "react-i18next";
import StrengthCard from "./StrengthStatisticsCard/StrengthStatisticsCard";
import StrengthStatisticsTable from "./StrengthStatisticsTable";
import StrengthUsage from "./StrengthStatisticsUsage/StrengthStatisticsUsage"

interface IStrengthStatistics {
    strengthStatistic: any
}

const StrengthCardsStatistics: FC<IStrengthStatistics> = (props) => {
    const { strengthStatistic } = props;

    const { t } = useTranslation();

    if (!strengthStatistic) {
        return (<div></div>)
    }

    return (
        <div className="strength_statistics_container">
            <h3 className="strength_cards_heading"> {t("strengthCardsYouUsedText")}:</h3>
            <div className="card_wrapper">

                {strengthStatistic.strengthCards.map((card: any, index: number) => {
                    return <StrengthCard strengthCard={card} key={index}/>

                })}
            </div>
            <div className="usage_wrapper">
                {strengthStatistic.numberOfUseForEachStrength.map((usage: any, index: number) => {
                    return <StrengthUsage strengthUsage={usage} key={index} />
                })}
            </div>

            <StrengthStatisticsTable  strengthCards={strengthStatistic.strengthCards}/>
        </div>
    )
};

export default StrengthCardsStatistics;